import { Profile } from './profile.model';
import { Topic } from './topic';
import { TylerMatTableDataSource } from './../../shared-components/angular-material/extended.class';

export class ProfileNode {
    data: Profile;
    parent: ProfileNode;
    children: ProfileNode[] = [];
    subTableData: TylerMatTableDataSource;
    selectedRow: ProfileNode;
    topic: Topic;
    first: boolean;
    last: boolean;

    // Methods
    hasChildren(): boolean {
    	// POST: returns true if this node has children
        return this.subTableData && this.subTableData.data.length > 0;
    }

    hasParent(profile: ProfileNode): boolean {
    	// PRE: a profile node
		// POST: returns true if the profile is a parent of this node
    	if (this.parent == null) {
    		return false;
		} else if (this.parent == profile) {
    		return true;
		} else {
    		return this.parent.hasParent(profile);
		}
	}

    checkSelectedRow() {
        // POST: checks if the row is selected by consulting the parents
        let previousSelected: ProfileNode = this;
        let currentNode: ProfileNode = this.parent;
        while (currentNode) {
            if (currentNode.selectedRow != previousSelected) {
                return false;
            }
            previousSelected = currentNode;
            currentNode = currentNode.parent;
        }
        return true;
    }

    getNestedLayers(layerCount = 0): number {
        // PRE: a layercount for recursion
        // POST: returns the depth of the deepest node in the tree to which this node belongs
        if (this.data.ParentID > 0) {
            if (this.parent) {
                return this.parent.getNestedLayers(layerCount + 1);
            }
        } else if (this.data.ProfileContentId > 0) {
            return layerCount + 1;
        } else {
            return layerCount;
        }
    }

    sortChildren() {
        // POST: sorts the children of this node in order of sequence
        this.children.sort((childA, childB) => {
            const childASequence = childA.data.newSequence != undefined ? childA.data.newSequence : childA.data.Sequence;
            const childBSequence = childB.data.newSequence != undefined ? childB.data.newSequence : childB.data.Sequence;
            if (childASequence < childBSequence) {
                return -1;
            } else if (childASequence > childBSequence) {
                return 1;
            } else {
                return 0;
            }
        });
        for (let i = 0; i < this.children.length; i++) {
            const child = this.children[i];
            if (i == 0) {
                child.first = true;
            } else {
                child.first = false;
            }
            if (i == this.children.length - 1) {
                child.last = true;
            } else {
                child.last = false;
            }
            child.sortChildren();
        }
    }

    getOpenedNodes(): Profile[] {
        // POST: obtains the opened class information beneath this now
        const openInformation: Profile[] = [];
        this.children.forEach(child => {
            if (this.subTableData.checkExpanded(child)) {
                openInformation.push(child.data);
            }
            openInformation.push.apply(openInformation, child.getOpenedNodes());
        });
        return openInformation;
    }

    openNodes(nodeData: Profile[]) {
        // POST: opens the subnodes that match the data
        this.children.forEach(child => {
            if (nodeData.find(data => data.RowId == child.data.RowId)) {
                this.subTableData.toggleExpanded(child);
                child.openNodes(nodeData);
            }
        });
    }
}